import React, {Component} from 'react';
class Footer extends Component {
  render() {
    return (
      <section className="hero">
        <div className="hero-body has-background-black has-text-white">
          <div className="container has-text-centered">
            <p>
              Full source code for this page in GITHUB<br/>
              Source code licensed  
              {' '}
              <a href="https://opensource.org/licenses/mit-license.php" className="has-text-primary">MIT</a>
              .
            </p>
            <br/>

            <p>
              <a href="https://bulma.io">
                <img
                  src="https://bulma.io/images/made-with-bulma--dark.png"
                  alt="Made with Bulma"
                  width="128"
                  height="24"
                />
              </a>
            </p>
          </div>
        </div>
      </section>
    );
  }
}

export default Footer;
